export const images = {
    bg: require('./bg.jpg'),
    start: require('./start.png'),
};
